//文件大小格式转化
export function formatFileSize(limit) {
  var size = "";
  if (limit < 0.1 * 1024) { //如果小于0.1KB转化成B  
    size = limit.toFixed(2) + "B";
  } else if (limit < 0.1 * 1024 * 1024) { //如果小于0.1MB转化成KB  
    size = (limit / 1024).toFixed(2) + "KB";
  } else if (limit < 0.1 * 1024 * 1024 * 1024) { //如果小于0.1GB转化成MB  
    size = (limit / (1024 * 1024)).toFixed(2) + "MB";
  } else { //其他转化成GB  
    size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";
  }
  var sizestr = size + "";
  var len = sizestr.indexOf("\.");
  var dec = sizestr.substr(len + 1, 2);
  if (dec == "00") { //当小数点后为00时 去掉小数部分  
    return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
  }
  return sizestr;
}

//过期时间格式转化
export function formatExpiredTime(expiredTime) {
  const currentTime = new Date().getTime();
  let diffTime = 0;
  let isBefore = false;
  if (currentTime >= expiredTime) {
    isBefore = true;
    diffTime = currentTime - expiredTime;
  } else {
    isBefore = false;
    diffTime = expiredTime - currentTime;
  }
  diffTime = (currentTime >= expiredTime) ? (currentTime - expiredTime) : (expiredTime - currentTime);
  let secondsTime = parseInt(diffTime / 1000);
  let minutesTime = parseInt(secondsTime / 60);
  let hoursTime = parseInt(minutesTime / 60);
  let daysTime = parseInt(hoursTime / 24);

  let timeStr = '';
  if (secondsTime < 60) {
    timeStr = `${secondsTime}秒`;
  } else if (minutesTime < 60) {
    timeStr = `${minutesTime}分钟`;
  } else if (hoursTime < 24) {
    timeStr = `${hoursTime}小时`;
  } else {
    timeStr = `${daysTime}天`;
  }
  timeStr = isBefore ? `${timeStr}前` : `${timeStr}后`;
  return timeStr;
}

//拼接参数
export function buildQueryParams(params) {
  return Object.keys(params).reduce((acc, cur, index) => {
    var key = cur;
    var value = params[key];
    if (key != null && value != null) {
      if (index > 0) {
        acc += "&"
      }
      acc += (key + "=" + value)
    }
    return acc;
  }, '');
}

//获取参数
export function getQueryParam(name) {
  let currentUrl = window.location.href;
  if (currentUrl.indexOf('?') > -1) {
    var query = currentUrl.split('?')[1];
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == name) return pair[1];
    }
  }
  return false;
}


export function generateUUID() {
  var d = new Date().getTime();
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
  return uuid;
}

// 浏览器是否无痕模式
export async function browserIsIncognito() {
  let result;
  await new Promise((resolve, reject) => {
    var fs = window.RequestFileSystem || window.webkitRequestFileSystem;
    if (!fs) {
      resolve(false);
    } else {
      fs(window.TEMPORARY, 100, () => {
        result = false;
        resolve(false)
      }, () => {
        result = true;
        resolve(true)
      });
    }
  });
  return result;
}


export function getALinkStr(str, className) {
  const allReg = /<a /g;
  const alls = str.match(allReg);
  if (alls && alls.length) {
    alls.forEach((item) => {
      str = str.replace(item, "<a target='_blank' ");
    })
  }
  return str;
}

//节流函数
export function throttle(fn, wait) {
  var timer = null;
  var pre = Date.now();
  return function () {
    var now = Date.now();
    var context = this;
    var args = arguments;
    clearTimeout(timer);
    if (now - pre >= wait) {
      fn.apply(context, args);
      pre = Date.now();
    } else {
      timer = setTimeout(() => {
        fn.apply(context, args);
      }, wait);
    }
  }
}

//防抖
export function debounce(fn, wait) {
  let timer = null;
  return function () {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, arguments);
    }, wait);
  }
}

//获取Referer参数的方法  getReferrerQueryString("xx")
export function getReferrerQueryString(name) {

  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = document.referrer.match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}


// WEBPACK FOOTER //
// ./src/utils/common.js